window._ = require('lodash');
global.$ = global.jquery = global.jQuery = require('jquery');
window.moment = require('moment');
window.moment().format();
global.flatpickr = require('flatpickr');

window.bootstrap = require('bootstrap');
require('select2');
require('datatables');
require('datatables.net-bs5');
require('datatables.net-responsive');
window.Swal = require('sweetalert2');
